import isPageBreak from './isPageBreak';

export default blocks => blocks.filter(block => isPageBreak(block));
